import { AudienceDto } from "@intelligems/ig-types";
import { isAnyOf } from "@reduxjs/toolkit";
import { AppDispatch, AppListenerMiddleware } from "@src/store";
import {
  clearAudience,
  deleteFilterRow,
  selectedAudience,
  setAudience,
  setAudienceElse,
  setAudienceExpression,
  updateAudienceRow,
} from "@src/store/slices/audiences";
import { isPriceTest } from "@src/store/slices/experiences/selectors/price/isPriceTest";
import { getControlGroup } from "@src/store/slices/variations";

export function setupAudiencesListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    matcher: isAnyOf(
      setAudience,
      clearAudience,
      deleteFilterRow,
      updateAudienceRow,
      setAudienceExpression
    ),
    effect: (_, { getState, dispatch }) => {
      const audience = selectedAudience(getState());
      const priceTest = isPriceTest(getState());
      const controlGroup = getControlGroup(getState());
      const update = createUpdate(dispatch, audience);
      const hasFilters = Boolean(audience.filters?.length);
      if (!hasFilters) {
        update({
          elseAction: null,
          elseVariationId: null,
          elseExcludeFromAnalytics: false,
        });
      } else if (audience.elseAction === null) {
        if (priceTest && controlGroup) {
          update({
            elseAction: "assignVariation",
            elseVariationId: controlGroup.id,
            elseExcludeFromAnalytics: true,
          });
        } else {
          update({
            elseAction: "experienceUnassigned",
            elseVariationId: null,
            elseExcludeFromAnalytics: false,
          });
        }
      }
    },
  });
}

function createUpdate(dispatch: AppDispatch, audience: AudienceDto) {
  return (payload: Required<Parameters<typeof setAudienceElse>[0]>) => {
    if (
      audience.elseAction !== payload.elseAction ||
      audience.elseVariationId !== payload.elseVariationId ||
      audience.elseExcludeFromAnalytics !== payload.elseExcludeFromAnalytics
    ) {
      dispatch(setAudienceElse(payload));
    }
  };
}
